import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const FieldsWrapper = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${theme.spacing.md};
  row-gap: 8px;
`

export const RadioGroup = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md} 0;
  border-top: 1px solid ${theme.colors.neutral.clear};
  border-bottom: 1px solid ${theme.colors.neutral.clear};

  span {
    font-size: ${theme.typography.sizes.xs};
  }
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
`

export const ButtonWrapper = styled.div``
